/* ═══════════════════════════════════════════════════
   AromaImperius V4 — Theme JS
   ═══════════════════════════════════════════════════ */
'use strict';

/* ── PRODUCTOS ──────────────────────────────────── */
const PRODUCTS = [
  // ── LANZAMIENTO OFICIAL ──
  { id:1,  name:'El Depredador',          insp:'Inspirado en Sauvage · Dior',            cat:'dia',    vibe:'fresco',   intensity:4, p30:249, p100:549, p30orig:399, p100orig:699, icon:'🌊', notes:['Bergamota','Ambroxan','Pimienta Rosa'], desc:'El más imitado del mundo. Bergamota salvaje que anuncia tu llegada antes de que entres al cuarto.', badge:'hot',  soon:false, variantId30:null, variantId100:null },
  { id:2,  name:'Marea Eterna',            insp:'Inspirado en Acqua di Gio · Armani',     cat:'dia',    vibe:'fresco',   intensity:3, p30:249, p100:549, p30orig:399, p100orig:699, icon:'🏄', notes:['Marino','Jazmín','Vetiver'],             desc:'El agua y tú. Frescura que dura todo el día sin pedir permiso. El clásico que nunca falla.',        badge:'hot',  soon:false, variantId30:null, variantId100:null },
  { id:3,  name:'El Que Todos Preguntan', insp:'Inspirado en Santal 33 · Le Labo',       cat:'tarde',  vibe:'amaderado',intensity:3, p30:249, p100:549, p30orig:399, p100orig:699, icon:'🪵', notes:['Sándalo','Cedro','Violeta'],             desc:'Ese olor que te persigue cuando alguien pasa. La gente pregunta siempre. Siempre.',               badge:'hot',  soon:false, variantId30:null, variantId100:null },
  { id:4,  name:'La Trampa Dulce',        insp:'Inspirado en Toy Boy · Moschino',        cat:'noche',  vibe:'dulce',    intensity:4, p30:249, p100:549, p30orig:399, p100orig:699, icon:'🍭', notes:['Bergamota','Geranio','Vetiver'],         desc:'Dulce con carácter. Entra suave, se queda en la memoria. Perfecto para cuando quieres impactar.',  badge:'new',  soon:false, variantId30:null, variantId100:null },
  { id:5,  name:'El Rey del Antro',       insp:'Inspirado en One Million · Paco Rabanne',cat:'noche',  vibe:'dulce',    intensity:5, p30:249, p100:549, p30orig:399, p100orig:699, icon:'👑', notes:['Pomelo','Canela','Pachulí'],             desc:'El rey de los cumplidos. Lo pones y no para la gente de preguntar qué llevas. Garantizado.',       badge:'hot',  soon:false, variantId30:null, variantId100:null },
  { id:6,  name:'Viento Libre',           insp:'Inspirado en Voyage · Nautica',          cat:'gym',    vibe:'fresco',   intensity:2, p30:249, p100:549, p30orig:399, p100orig:699, icon:'💨', notes:['Manzana','Cedro','Almizcle'],           desc:'Fresco limpio que va con todo. Para el gym, la oficina o el domingo. No falla nunca.',              badge:'new',  soon:false, variantId30:null, variantId100:null },
  { id:7,  name:'La Noche es Tuya',       insp:'Inspirado en 212 VIP Black · C. Herrera',cat:'noche',  vibe:'amaderado',intensity:4, p30:249, p100:549, p30orig:399, p100orig:699, icon:'🌙', notes:['Cardamomo','Cuero','Almizle'],          desc:'Para cuando la noche es tuya y lo sabes. Oscuro, denso, irresistible. El club en una botella.',     badge:'hot',  soon:false, variantId30:null, variantId100:null },
  // ── PRÓXIMAMENTE ──
  { id:8,  name:'El Baja Tangas',         insp:'Inspirado en Eros · Versace',            cat:'noche',  vibe:'dulce',    intensity:5, p30:249, p100:549, p30orig:399, p100orig:699, icon:'⚡', notes:['Menta Fresca','Vainilla','Cedro'],      desc:'El favorito de los que saben. Dulce al principio, un animal después. Sin explicación.',             badge:'soon', soon:true,  variantId30:null, variantId100:null },
  { id:9,  name:'El Favorito de Ellas',   insp:'Inspirado en 212 Men · C. Herrera',      cat:'dia',    vibe:'fresco',   intensity:3, p30:249, p100:549, p30orig:399, p100orig:699, icon:'🏙️', notes:['Salvia','Cedro','Almizcle Blanco'],    desc:'El del chico de ciudad. Fresco, sofisticado, elegante. El que le gusta a todo el mundo.',           badge:'soon', soon:true,  variantId30:null, variantId100:null },
  { id:10, name:'La Sorpresa',            insp:'Inspirado en Paris Hilton for Men',      cat:'tarde',  vibe:'dulce',    intensity:3, p30:249, p100:549, p30orig:399, p100orig:699, icon:'🎁', notes:['Bergamota','Jazmín','Ámbar'],           desc:'No lo esperas. Lo pruebas. Lo compras. Lo de siempre, pero con algo que no puedes describir.',      badge:'soon', soon:true,  variantId30:null, variantId100:null },
  { id:11, name:'Fuego Frío',             insp:'Inspirado en Tobacco Vanille · Tom Ford',cat:'tarde',  vibe:'amaderado',intensity:5, p30:249, p100:549, p30orig:399, p100orig:699, icon:'🔥', notes:['Tabaco','Vainilla','Cedro Oscuro'],     desc:'Calor y frío al mismo tiempo. Tabaco y vainilla que nadie olvida. El más premium del catálogo.',    badge:'soon', soon:true,  variantId30:null, variantId100:null },
  { id:12, name:'El Invencible',          insp:'Inspirado en Invictus · Paco Rabanne',   cat:'gym',    vibe:'fresco',   intensity:4, p30:249, p100:549, p30orig:399, p100orig:699, icon:'🏆', notes:['Pomelo','Pimienta Marina','Guayaco'],   desc:'Ganador. Fresco e intenso. Literalmente diseñado para los que no conocen la derrota.',              badge:'soon', soon:true,  variantId30:null, variantId100:null },
  { id:13, name:'Marea Oscura',           insp:'Inspirado en Acqua di Gio Absolu · Armani',cat:'tarde', vibe:'amaderado',intensity:4, p30:249, p100:549, p30orig:399, p100orig:699, icon:'🌊', notes:['Incienso','Patchulí','Notas Marinas'],  desc:'La versión más profunda del mar. Para los que quieren la frescura, pero con más presencia.',        badge:'soon', soon:true,  variantId30:null, variantId100:null },
];

/* ── QUIZ MAP ────────────────────────────────────── */
const QUIZ_MAP = {
  'dia-fresco-1':[6,2,1], 'dia-fresco-2':[1,2,6], 'dia-fresco-3':[1,2,3], 'dia-fresco-4':[1,3], 'dia-fresco-5':[3,1],
  'dia-dulce-1': [4,5],   'dia-dulce-2': [4,5],   'dia-dulce-3': [5,4],   'dia-dulce-4': [5,7],  'dia-dulce-5': [5,7],
  'dia-amaderado-1':[3,6],'dia-amaderado-2':[3,6],'dia-amaderado-3':[3,13],'dia-amaderado-4':[3,11],'dia-amaderado-5':[11,3],
  'dia-lujo-1':  [3,6],   'dia-lujo-2':  [3,11],  'dia-lujo-3':  [3,11],  'dia-lujo-4':  [11,3], 'dia-lujo-5':  [11,3],
  'tarde-fresco-1':[6,2], 'tarde-fresco-2':[2,1], 'tarde-fresco-3':[1,2], 'tarde-fresco-4':[1,3],'tarde-fresco-5':[3,1],
  'tarde-dulce-1':[4,10], 'tarde-dulce-2':[4,10], 'tarde-dulce-3':[5,4],  'tarde-dulce-4':[5,7], 'tarde-dulce-5':[5,7],
  'tarde-amaderado-1':[3,13],'tarde-amaderado-2':[13,3],'tarde-amaderado-3':[3,11],'tarde-amaderado-4':[11,3],'tarde-amaderado-5':[11,3],
  'tarde-lujo-1':[3,11],  'tarde-lujo-2':[3,11],  'tarde-lujo-3':[11,3],  'tarde-lujo-4':[11,3], 'tarde-lujo-5':[11,3],
  'noche-fresco-1':[7,6], 'noche-fresco-2':[7,1], 'noche-fresco-3':[7,5], 'noche-fresco-4':[5,7],'noche-fresco-5':[5,7],
  'noche-dulce-1':[4,8],  'noche-dulce-2':[5,4],  'noche-dulce-3':[5,8],  'noche-dulce-4':[8,5], 'noche-dulce-5':[8,5],
  'noche-amaderado-1':[7,3],'noche-amaderado-2':[7,11],'noche-amaderado-3':[7,11],'noche-amaderado-4':[11,7],'noche-amaderado-5':[11,7],
  'noche-lujo-1':[7,3],   'noche-lujo-2':[7,11],  'noche-lujo-3':[11,7],  'noche-lujo-4':[11,7], 'noche-lujo-5':[11,7],
  'gym-fresco-1':[6,12],  'gym-fresco-2':[6,2],   'gym-fresco-3':[6,12],  'gym-fresco-4':[12,6], 'gym-fresco-5':[12,6],
  'gym-dulce-1': [6,2],   'gym-dulce-2': [6,2],   'gym-dulce-3': [6,12],  'gym-dulce-4': [12,6], 'gym-dulce-5': [12,6],
  'gym-amaderado-1':[6,3],'gym-amaderado-2':[6,3],'gym-amaderado-3':[6,12],'gym-amaderado-4':[12,6],'gym-amaderado-5':[12,6],
  'gym-lujo-1':  [3,6],   'gym-lujo-2':  [3,6],   'gym-lujo-3':  [3,12],  'gym-lujo-4':  [3,12], 'gym-lujo-5':  [3,12],
};

const INTENSITY_LABELS = [
  'Que solo lo sientan si se acercan mucho',
  'Presente pero no invasivo',
  'Que se quede en el cuarto cuando te vayas',
  'Que te recuerden toda la tarde',
  'Aplastante — que no te olviden en días'
];

/* ── CART STATE ─────────────────────────────────── */
const Cart = {
  items: JSON.parse(localStorage.getItem('ai_cart')||'[]'),
  save(){ localStorage.setItem('ai_cart', JSON.stringify(this.items)); },
  add(productId, vol){
    const p = PRODUCTS.find(x=>x.id===productId);
    if(!p || p.soon) return;
    const price = vol==='30ml' ? p.p30 : p.p100;
    const key = `${productId}-${vol}`;
    const existing = this.items.find(i=>i.key===key);
    if(existing){ existing.qty++; }
    else { this.items.push({key, productId, name:p.name, vol, price, qty:1, icon:p.icon}); }
    this.save(); this.updateUI(); CartDrawer.open();
    Notif.show('¡Agregado!', `${p.name} (${vol}) en tu carrito`, 'success');
  },
  remove(key){ this.items = this.items.filter(i=>i.key!==key); this.save(); this.updateUI(); },
  setQty(key, qty){
    if(qty<1){ this.remove(key); return; }
    const item = this.items.find(i=>i.key===key);
    if(item){ item.qty=qty; this.save(); this.updateUI(); }
  },
  get total(){ return this.items.reduce((s,i)=>s+i.price*i.qty,0); },
  get count(){ return this.items.reduce((s,i)=>s+i.qty,0); },
  updateUI(){
    document.querySelectorAll('.cart-count').forEach(el=>{ el.textContent=this.count; el.style.display=this.count>0?'flex':'none'; });
    CartDrawer.render();
  }
};

/* ── CART DRAWER ────────────────────────────────── */
const CartDrawer = {
  el: null, overlay: null,
  init(){
    this.el = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    if(!this.el) return;
    this.overlay.addEventListener('click',()=>this.close());
    document.getElementById('cart-close')?.addEventListener('click',()=>this.close());
    this.render();
  },
  open(){
    this.el?.classList.add('open');
    this.overlay?.classList.add('open');
    document.body.style.overflow='hidden';
  },
  close(){
    this.el?.classList.remove('open');
    this.overlay?.classList.remove('open');
    document.body.style.overflow='';
  },
  render(){
    const itemsEl = document.getElementById('cart-items-list');
    const subtotalEl = document.getElementById('cart-subtotal-amt');
    const shippingFill = document.getElementById('cart-shipping-fill');
    const shippingText = document.getElementById('cart-shipping-text');
    if(!itemsEl) return;
    const FREE = 999;
    const remaining = FREE - Cart.total;
    if(shippingFill) shippingFill.style.width = `${Math.min(100, Cart.total/FREE*100)}%`;
    if(shippingText){
      if(Cart.total>=FREE) shippingText.innerHTML='🎉 <strong>¡Envío gratis desbloqueado!</strong>';
      else shippingText.innerHTML=`Te faltan <strong>$${remaining.toLocaleString()}</strong> para envío gratis`;
    }
    if(Cart.items.length===0){
      itemsEl.innerHTML=`<div class="cart-empty"><div class="icon">🛒</div><h3>Tu carrito está vacío</h3><p>Agrega alguna fragancia para empezar</p></div>`;
    } else {
      itemsEl.innerHTML = Cart.items.map(item=>`
        <div class="cart-item" data-key="${item.key}">
          <div class="cart-item-img">${item.icon}</div>
          <div class="cart-item-info">
            <div class="cart-item-name">${item.name}</div>
            <div class="cart-item-variant">${item.vol} · Eau de Parfum</div>
            <div class="cart-item-controls">
              <div class="qty-control">
                <button class="qty-btn" onclick="Cart.setQty('${item.key}',${item.qty-1})">−</button>
                <span class="qty-num">${item.qty}</span>
                <button class="qty-btn" onclick="Cart.setQty('${item.key}',${item.qty+1})">+</button>
              </div>
              <span class="cart-item-price">$${(item.price*item.qty).toLocaleString()}</span>
            </div>
            <button class="cart-item-remove" onclick="Cart.remove('${item.key}')">✕ Quitar</button>
          </div>
        </div>`).join('');
    }
    if(subtotalEl) subtotalEl.textContent = `$${Cart.total.toLocaleString()} MXN`;
  }
};

/* ── CURSOR ─────────────────────────────────────── */
const Cursor = {
  dot:null, ring:null, mx:0, my:0, rx:0, ry:0,
  init(){
    if(window.matchMedia('(hover:none)').matches) return;
    const wrap = document.createElement('div'); wrap.className='ai-cursor';
    this.dot  = Object.assign(document.createElement('div'),{className:'ai-cursor__dot'});
    this.ring = Object.assign(document.createElement('div'),{className:'ai-cursor__ring'});
    wrap.append(this.dot, this.ring); document.body.append(wrap);
    document.addEventListener('mousemove',e=>{this.mx=e.clientX;this.my=e.clientY;this.dot.style.cssText=`left:${e.clientX}px;top:${e.clientY}px`;});
    document.querySelectorAll('a,button,.product-card,.quiz-choice,.bundle-choice').forEach(el=>{
      el.addEventListener('mouseenter',()=>{ wrap.classList.add('ai-cursor--hover'); });
      el.addEventListener('mouseleave',()=>{ wrap.classList.remove('ai-cursor--hover'); });
    });
    document.addEventListener('mousedown',()=>wrap.classList.add('ai-cursor--click'));
    document.addEventListener('mouseup',()=>wrap.classList.remove('ai-cursor--click'));
    this.tick();
  },
  tick(){
    this.rx += (this.mx - this.rx)*.12;
    this.ry += (this.my - this.ry)*.12;
    this.ring.style.cssText=`left:${this.rx}px;top:${this.ry}px`;
    requestAnimationFrame(()=>this.tick());
  }
};

/* ── PARTICLES ──────────────────────────────────── */
const Particles = {
  init(){
    const canvas = document.getElementById('hero-canvas');
    if(!canvas) return;
    const ctx = canvas.getContext('2d');
    let W, H, pts = [];
    const resize = ()=>{ W=canvas.width=canvas.offsetWidth; H=canvas.height=canvas.offsetHeight; };
    resize(); window.addEventListener('resize', resize);
    for(let i=0;i<55;i++) pts.push({ x:Math.random()*W, y:Math.random()*H, vx:(Math.random()-.5)*.3, vy:(Math.random()-.5)*.3, r:Math.random()*1.5+.5, o:Math.random()*.5+.15 });
    const draw=()=>{
      ctx.clearRect(0,0,W,H);
      pts.forEach(p=>{
        p.x+=p.vx; p.y+=p.vy;
        if(p.x<0||p.x>W) p.vx*=-1;
        if(p.y<0||p.y>H) p.vy*=-1;
        ctx.beginPath(); ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
        ctx.fillStyle=`rgba(200,168,74,${p.o})`; ctx.fill();
      });
      pts.forEach((a,i)=>pts.forEach((b,j)=>{
        if(j<=i) return;
        const d=Math.hypot(a.x-b.x,a.y-b.y);
        if(d<100){ ctx.beginPath(); ctx.moveTo(a.x,a.y); ctx.lineTo(b.x,b.y); ctx.strokeStyle=`rgba(200,168,74,${.08*(1-d/100)})`; ctx.lineWidth=.5; ctx.stroke(); }
      }));
      requestAnimationFrame(draw);
    };
    draw();
  }
};

/* ── REVEAL ─────────────────────────────────────── */
const Reveal = {
  init(){
    const io = new IntersectionObserver(entries=>{
      entries.forEach(e=>{ if(e.isIntersecting) e.target.classList.add('revealed'); });
    },{ threshold:.12 });
    document.querySelectorAll('.reveal,.reveal-scale').forEach(el=>io.observe(el));
  }
};

/* ── CATALOG FILTERS ────────────────────────────── */
const Catalog = {
  filter:'todos',
  init(){
    this.render();
    document.querySelectorAll('.filter-btn').forEach(btn=>{
      btn.addEventListener('click',()=>{
        this.filter = btn.dataset.filter;
        document.querySelectorAll('.filter-btn').forEach(b=>b.classList.toggle('active', b===btn));
        this.render();
      });
    });
  },
  render(){
    const grid = document.getElementById('catalog-grid');
    if(!grid) return;
    const visible = this.filter==='todos' ? PRODUCTS : PRODUCTS.filter(p=>p.cat===this.filter||p.vibe===this.filter);
    grid.innerHTML = visible.map(p=>`
      <div class="product-card${p.soon?' soon':''} reveal" data-id="${p.id}" style="--card-color:${p.soon?'#6A5E4C':'#C8A84A'}">
        <div class="product-card-img">
          ${p.img ? `<img src="${p.img}" alt="${p.name}" loading="lazy">` : `<div class="placeholder-icon">${p.icon}</div>`}
          <div class="product-card-badge">
            ${p.badge==='hot'&&!p.soon?'<span class="badge badge-hot">🔥 Hot</span>':''}
            ${p.badge==='new'&&!p.soon?'<span class="badge badge-new">Nuevo</span>':''}
            ${p.soon?'<span class="badge badge-soon">Próximamente</span>':''}
          </div>
          ${!p.soon?`<button class="product-wishlist" onclick="event.stopPropagation();this.classList.toggle('active')">♡</button>`:''}
          ${p.soon?`<div class="soon-overlay"><div class="soon-badge">Próximamente<span>En 15 días</span></div></div>`:''}
        </div>
        <div class="product-card-body">
          <div class="product-cat">${p.cat} · ${p.vibe}</div>
          <div class="product-name">${p.name}</div>
          <div class="product-insp">${p.insp}</div>
          <div class="product-notes">${p.notes.slice(0,3).map(n=>`<span class="product-note">${n}</span>`).join('')}</div>
          <div class="product-price-row">
            <div class="product-prices">
              <span class="product-price-s">30ml <strong style="color:var(--ob);font-family:var(--ff-serif)">$${p.p30.toLocaleString()}</strong></span>
              <span class="product-price">100ml $${p.p100.toLocaleString()}</span>
            </div>
            ${!p.soon?`<button class="product-add" onclick="Cart.add(${p.id},'100ml')" title="Agregar al carrito">+</button>`:'<button class="product-add" disabled>⏳</button>'}
          </div>
        </div>
      </div>`).join('');
    Reveal.init();
    if(window.Tilt) initTilt();
  }
};

/* ── 3D CARD TILT ───────────────────────────────── */
function initTilt(){
  document.querySelectorAll('.product-card:not(.soon)').forEach(card=>{
    card.addEventListener('mousemove',e=>{
      const r=card.getBoundingClientRect();
      const x=(e.clientX-r.left)/r.width-.5;
      const y=(e.clientY-r.top)/r.height-.5;
      card.style.transform=`translateY(-8px) rotateX(${-y*10}deg) rotateY(${x*10}deg)`;
    });
    card.addEventListener('mouseleave',()=>{ card.style.transform=''; });
  });
}

/* ── QUIZ ───────────────────────────────────────── */
const Quiz = {
  step:1, answers:{}, totalSteps:4,
  init(){
    if(!document.getElementById('quiz-step-1')) return;
    this.goTo(1);
    document.querySelectorAll('.quiz-choice').forEach(el=>{
      el.addEventListener('click',()=>{
        const group = el.closest('.quiz-choices')?.dataset.group;
        el.closest('.quiz-choices')?.querySelectorAll('.quiz-choice').forEach(c=>c.classList.remove('selected'));
        el.classList.add('selected');
        this.answers[group] = el.dataset.value;
        setTimeout(()=>this.next(), 350);
      });
    });
    document.getElementById('quiz-slider')?.addEventListener('input',e=>{
      const v = parseInt(e.target.value);
      this.answers.intensity = v;
      const disp = document.getElementById('quiz-intensity-text');
      if(disp) disp.textContent = INTENSITY_LABELS[v-1];
      document.querySelectorAll('.quiz-slider-label').forEach((l,i)=>l.classList.toggle('active',i===v-1));
    });
    document.getElementById('quiz-next-btn')?.addEventListener('click',()=>this.next());
    document.getElementById('quiz-back-btn')?.addEventListener('click',()=>this.prev());
    document.getElementById('quiz-restart')?.addEventListener('click',()=>this.restart());
    this.answers.intensity = 3;
  },
  goTo(step){
    this.step = step;
    document.querySelectorAll('.quiz-step').forEach((el,i)=>{
      el.classList.remove('active','prev');
      if(i+1===step) el.classList.add('active');
      if(i+1<step) el.classList.add('prev');
    });
    document.querySelectorAll('.quiz-dot').forEach((d,i)=>{
      d.classList.toggle('active',i+1===step);
      d.classList.toggle('done',i+1<step);
    });
    const fill = document.getElementById('quiz-progress');
    if(fill) fill.style.width=`${((step-1)/(this.totalSteps-1))*100}%`;
    const backBtn = document.getElementById('quiz-back-btn');
    const nextBtn = document.getElementById('quiz-next-btn');
    if(backBtn) backBtn.style.visibility = step>1?'visible':'hidden';
    if(nextBtn) nextBtn.style.display = step===3?'flex':(step===4?'none':'none');
    if(step===4) this.showResult();
  },
  next(){
    if(this.step===3){
      if(!this.answers.intensity) this.answers.intensity=3;
      this.goTo(4); return;
    }
    if(this.step<this.totalSteps) this.goTo(this.step+1);
  },
  prev(){ if(this.step>1) this.goTo(this.step-1); },
  restart(){
    this.answers={}; this.answers.intensity=3;
    document.querySelectorAll('.quiz-choice').forEach(c=>c.classList.remove('selected'));
    this.goTo(1);
  },
  showResult(){
    const {moment='dia', vibe='fresco', intensity=3} = this.answers;
    const key = `${moment}-${vibe}-${intensity}`;
    let ids = QUIZ_MAP[key] || QUIZ_MAP[`${moment}-${vibe}-3`] || [1,5,7];
    const rList = document.getElementById('quiz-result-list');
    if(!rList) return;
    const available = ids.map(id=>PRODUCTS.find(p=>p.id===id)).filter(Boolean).slice(0,3);
    const pct = [99,92,87];
    rList.innerHTML = available.map((p,i)=>`
      <div class="quiz-result-card">
        <div class="quiz-result-icon">${p.icon}</div>
        <span class="quiz-result-match">${pct[i]}% match</span>
        <div class="quiz-result-name">${p.name}</div>
        <div class="quiz-result-insp">${p.insp}</div>
        <div class="quiz-result-price">$${p.p100.toLocaleString()} MXN</div>
        ${!p.soon?`<button class="btn btn-gold btn-sm btn-full" style="margin-top:12px" onclick="Cart.add(${p.id},'100ml')">Agregar</button>`:'<span style="font-size:.75rem;color:var(--tx3);margin-top:8px;display:block">Próximamente</span>'}
      </div>`).join('');
  }
};

/* ── BUNDLE ─────────────────────────────────────── */
const Bundle = {
  selected:[], max:5,
  tiers:[{n:2,pct:10},{n:3,pct:15},{n:4,pct:20},{n:5,pct:25}],
  init(){
    if(!document.getElementById('bundle-drop')) return;
    this.renderCatalog();
    this.updateSummary();
  },
  toggle(id){
    const p = PRODUCTS.find(x=>x.id===id);
    if(!p||p.soon) return;
    const idx = this.selected.indexOf(id);
    if(idx>-1){ this.selected.splice(idx,1); }
    else if(this.selected.length<this.max){ this.selected.push(id); }
    else { Notif.show('Máximo alcanzado','El bundle admite hasta 5 fragancias','error'); return; }
    this.renderDrop();
    this.renderCatalog();
    this.updateSummary();
  },
  renderDrop(){
    const drop = document.getElementById('bundle-drop');
    if(!drop) return;
    if(this.selected.length===0){
      drop.classList.remove('has-items');
      drop.innerHTML=`<div class="bundle-drop-empty"><div class="icon">✨</div><p>Elige entre 2 y 5 fragancias para armar tu bundle con descuento</p></div>`;
      return;
    }
    drop.classList.add('has-items');
    drop.innerHTML = this.selected.map(id=>{
      const p=PRODUCTS.find(x=>x.id===id);
      return `<div class="bundle-item"><span class="bundle-item-icon">${p.icon}</span><div class="bundle-item-info"><div class="bundle-item-name">${p.name}</div><div class="bundle-item-price">$${p.p100.toLocaleString()}</div></div><button class="bundle-item-remove" onclick="Bundle.toggle(${id})">✕</button></div>`;
    }).join('');
  },
  renderCatalog(){
    const grid = document.getElementById('bundle-catalog');
    if(!grid) return;
    grid.innerHTML = PRODUCTS.filter(p=>!p.soon).map(p=>`
      <div class="bundle-choice${this.selected.includes(p.id)?' added':''}" onclick="Bundle.toggle(${p.id})">
        <div class="bundle-choice-icon">${p.icon}</div>
        <div class="bundle-choice-name">${p.name}</div>
        <div class="bundle-choice-price">$${p.p100.toLocaleString()}</div>
        ${this.selected.includes(p.id)?'<div style="font-size:.7rem;color:var(--go);margin-top:4px">✓ En bundle</div>':''}
      </div>`).join('') +
      PRODUCTS.filter(p=>p.soon).map(p=>`<div class="bundle-choice disabled"><div class="bundle-choice-icon">${p.icon}</div><div class="bundle-choice-name">${p.name}</div><div class="bundle-choice-soon">Próximamente</div></div>`).join('');
  },
  updateSummary(){
    const n = this.selected.length;
    const tier = [...this.tiers].reverse().find(t=>n>=t.n);
    const pct = tier?.pct || 0;
    const original = this.selected.reduce((s,id)=>{const p=PRODUCTS.find(x=>x.id===id);return s+(p?p.p100:0);},0);
    const final = Math.round(original*(1-pct/100));
    const saving = original - final;
    document.querySelectorAll('.discount-tier').forEach(el=>{
      const req=parseInt(el.dataset.req);
      el.classList.toggle('active',n>=req);
    });
    const origEl=document.getElementById('bundle-original');
    const finalEl=document.getElementById('bundle-final');
    const savingEl=document.getElementById('bundle-saving');
    if(origEl) origEl.textContent=original>0?`$${original.toLocaleString()} MXN`:'';
    if(finalEl) finalEl.textContent=final>0?`$${final.toLocaleString()} MXN`:'—';
    if(savingEl) savingEl.textContent=saving>0?`Ahorras $${saving.toLocaleString()} MXN`:'';
    const addBtn=document.getElementById('bundle-add-btn');
    if(addBtn) addBtn.disabled=n<2;
  },
  addToCart(){
    if(this.selected.length<2) return;
    this.selected.forEach(id=>Cart.add(id,'100ml'));
    Notif.show('¡Bundle agregado! 🎉',`${this.selected.length} fragancias añadidas al carrito`,'success');
  }
};

/* ── NOTIFICATIONS ──────────────────────────────── */
const Notif = {
  container: null,
  init(){ this.container=document.getElementById('notif-container'); },
  show(title, msg, type=''){
    if(!this.container) return;
    const el=document.createElement('div');
    el.className=`notif ${type}`;
    el.innerHTML=`<span class="notif-icon">${type==='success'?'✓':type==='error'?'✕':'ℹ'}</span><div class="notif-text"><strong>${title}</strong><span>${msg}</span></div>`;
    this.container.prepend(el);
    requestAnimationFrame(()=>el.classList.add('show'));
    setTimeout(()=>{ el.classList.remove('show'); setTimeout(()=>el.remove(),400); },3500);
  }
};

/* ── POPUP DESCUENTO ────────────────────────────── */
const Popup = {
  shown: false,
  code: 'BIENVENIDO15',
  init(){
    if(sessionStorage.getItem('ai_popup_shown')) return;
    setTimeout(()=>this.show(), 10000);
  },
  show(){
    if(this.shown) return; this.shown=true;
    document.getElementById('discount-popup')?.classList.add('show');
    sessionStorage.setItem('ai_popup_shown','1');
    this.startTimer(10*60);
  },
  hide(){ document.getElementById('discount-popup')?.classList.remove('show'); },
  copy(){
    navigator.clipboard?.writeText(this.code).then(()=>{
      const btn=document.getElementById('popup-copy-btn');
      if(btn){ btn.textContent='¡Copiado! ✓'; btn.classList.add('copied'); setTimeout(()=>{ btn.textContent='Copiar'; btn.classList.remove('copied'); },2000); }
    });
  },
  startTimer(seconds){
    const m=document.getElementById('popup-min');
    const s=document.getElementById('popup-sec');
    const tick=()=>{
      if(!document.getElementById('discount-popup')?.classList.contains('show')) return;
      const mm=Math.floor(seconds/60); const ss=seconds%60;
      if(m) m.textContent=String(mm).padStart(2,'0');
      if(s) s.textContent=String(ss).padStart(2,'0');
      if(seconds>0){ seconds--; setTimeout(tick,1000); }
    };
    tick();
  }
};

/* ── COUNTDOWN (urgency bar) ────────────────────── */
const Countdown = {
  init(){
    const stored = sessionStorage.getItem('ai_countdown');
    const end = stored ? parseInt(stored) : Date.now() + 3*60*60*1000;
    if(!stored) sessionStorage.setItem('ai_countdown', end.toString());
    const tick=()=>{
      const diff=Math.max(0, end-Date.now());
      const h=Math.floor(diff/3600000); const m=Math.floor((diff%3600000)/60000); const s=Math.floor((diff%60000)/1000);
      document.getElementById('cd-h')&&(document.getElementById('cd-h').textContent=String(h).padStart(2,'0'));
      document.getElementById('cd-m')&&(document.getElementById('cd-m').textContent=String(m).padStart(2,'0'));
      document.getElementById('cd-s')&&(document.getElementById('cd-s').textContent=String(s).padStart(2,'0'));
      if(diff>0) setTimeout(tick,1000);
    };
    tick();
  }
};

/* ── HEADER SCROLL ──────────────────────────────── */
const Header = {
  init(){
    const h=document.getElementById('site-header');
    if(!h) return;
    const update=()=>{ h.classList.toggle('scrolled',window.scrollY>60); h.classList.toggle('at-top',window.scrollY<=60); };
    window.addEventListener('scroll',update,{passive:true}); update();
    document.getElementById('cart-btn')?.addEventListener('click',()=>CartDrawer.open());
    document.getElementById('hamburger-btn')?.addEventListener('click',()=>MobileNav.open());
  }
};

/* ── MOBILE NAV ─────────────────────────────────── */
const MobileNav = {
  init(){
    document.querySelector('.mobile-nav-backdrop')?.addEventListener('click',()=>this.close());
    document.getElementById('mobile-nav-close')?.addEventListener('click',()=>this.close());
  },
  open(){ document.getElementById('mobile-nav')?.classList.add('open'); document.body.style.overflow='hidden'; },
  close(){ document.getElementById('mobile-nav')?.classList.remove('open'); document.body.style.overflow=''; }
};

/* ── NEWSLETTER ─────────────────────────────────── */
const Newsletter = {
  init(){
    document.getElementById('newsletter-form')?.addEventListener('submit',e=>{
      e.preventDefault();
      const email=document.getElementById('newsletter-email')?.value;
      if(email){ Notif.show('¡Bienvenido! 🎉','Revisa tu email — tienes un regalo esperándote','success'); e.target.reset(); }
    });
  }
};

/* ── ANNOUNCE BAR DUPLICATE ──────────────────────── */
const Announce = {
  init(){
    const t=document.querySelector('.announce-track');
    if(t){ const clone=t.cloneNode(true); t.parentNode.appendChild(clone); }
  }
};

/* ── HERO BOTTLE SVG INJECT ─────────────────────── */
const HeroBottle = {
  init(){
    const wrap = document.getElementById('hero-bottle-svg');
    if(!wrap) return;
    wrap.innerHTML = `
    <svg viewBox="0 0 200 480" xmlns="http://www.w3.org/2000/svg" overflow="visible">
      <defs>
        <linearGradient id="bG" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#251E32"/><stop offset="25%" stop-color="#1A1424"/><stop offset="75%" stop-color="#201830"/><stop offset="100%" stop-color="#0C0A16"/></linearGradient>
        <linearGradient id="lG" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#C8A84A" stop-opacity="0.9"/><stop offset="50%" stop-color="#E8C870" stop-opacity="0.7"/><stop offset="100%" stop-color="#9A7C2C" stop-opacity="0.8"/></linearGradient>
        <linearGradient id="cG" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#2A2230"/><stop offset="100%" stop-color="#181420"/></linearGradient>
        <radialGradient id="liqG" cx="40%" cy="50%"><stop offset="0%" stop-color="#C8A84A" stop-opacity="0.3"/><stop offset="100%" stop-color="#9A7C2C" stop-opacity="0.08"/></radialGradient>
        <filter id="glow"><feGaussianBlur stdDeviation="3" result="blur"/><feMerge><feMergeNode in="blur"/><feMergeNode in="SourceGraphic"/></feMerge></filter>
        <clipPath id="bodyClip"><rect x="40" y="78" width="120" height="324" rx="8"/></clipPath>
      </defs>
      <!-- Shadow -->
      <ellipse cx="100" cy="420" rx="62" ry="14" fill="rgba(0,0,0,0.25)"/>
      <!-- Body -->
      <rect x="40" y="78" width="120" height="324" rx="8" fill="url(#bG)"/>
      <!-- Liquid -->
      <rect x="40" y="78" width="120" height="324" rx="8" fill="url(#liqG)" clip-path="url(#bodyClip)"/>
      <!-- Highlight left -->
      <rect x="43" y="84" width="16" height="306" rx="6" fill="white" fill-opacity="0.06"/>
      <!-- Gold border -->
      <rect x="40" y="78" width="120" height="324" rx="8" fill="none" stroke="url(#lG)" stroke-width="0.8" stroke-opacity="0.5"/>
      <!-- LABEL background -->
      <rect x="52" y="160" width="96" height="190" rx="4" fill="#0A0908" fill-opacity="0.95"/>
      <!-- Label gold border outer -->
      <rect x="52" y="160" width="96" height="190" rx="4" fill="none" stroke="url(#lG)" stroke-width="0.9"/>
      <!-- Label gold border inner -->
      <rect x="56" y="164" width="88" height="182" rx="3" fill="none" stroke="#C8A84A" stroke-width="0.3" stroke-opacity="0.3"/>
      <!-- Brand AI initials -->
      <text x="100" y="196" text-anchor="middle" font-family="Georgia, serif" font-size="12" fill="#C8A84A" font-style="italic" filter="url(#glow)">AI</text>
      <!-- Rule -->
      <line x1="62" y1="202" x2="138" y2="202" stroke="#C8A84A" stroke-width="0.5" stroke-opacity="0.5"/>
      <!-- Brand name -->
      <text x="100" y="214" text-anchor="middle" font-family="Arial" font-size="6.5" fill="#D4B07A" letter-spacing="2.5">AROMAIMPERIUS</text>
      <!-- Rule 2 -->
      <line x1="65" y1="218" x2="135" y2="218" stroke="#C8A84A" stroke-width="0.3" stroke-opacity="0.3"/>
      <!-- Product name lines -->
      <text x="100" y="238" text-anchor="middle" font-family="Georgia, serif" font-size="13" fill="#F5E8C0" font-style="italic">El Depredador</text>
      <!-- EDP type -->
      <text x="100" y="260" text-anchor="middle" font-family="Arial" font-size="5.5" fill="#9A8E7C" letter-spacing="1.5">EAU DE PARFUM</text>
      <!-- Diamond ornament -->
      <polygon points="100,275 103.5,278.5 100,282 96.5,278.5" fill="#C8A84A" opacity="0.6"/>
      <!-- Intensity dots -->
      <circle cx="86" cy="300" r="3" fill="#C8A84A" opacity="0.8"/>
      <circle cx="94" cy="300" r="3" fill="#C8A84A" opacity="0.8"/>
      <circle cx="102" cy="300" r="3" fill="#C8A84A" opacity="0.8"/>
      <circle cx="110" cy="300" r="3" fill="#C8A84A" opacity="0.4"/>
      <circle cx="118" cy="300" r="3" fill="#C8A84A" opacity="0.15"/>
      <!-- Rule bottom -->
      <line x1="62" y1="316" x2="138" y2="316" stroke="#C8A84A" stroke-width="0.3" stroke-opacity="0.3"/>
      <!-- Volume -->
      <text x="100" y="326" text-anchor="middle" font-family="Arial" font-size="5.5" fill="#9A7C2C" letter-spacing="1">100 ML · ESENCIAS SELECCIONADAS</text>
      <!-- Neck -->
      <rect x="72" y="46" width="56" height="33" rx="4" fill="url(#cG)"/>
      <rect x="68" y="75" width="64" height="5" fill="#C8A84A" fill-opacity="0.7"/>
      <!-- Cap layers -->
      <rect x="60" y="14" width="80" height="33" rx="6" fill="url(#cG)"/>
      <rect x="62" y="16" width="76" height="29" rx="5" fill="#201830" fill-opacity="0.5"/>
      <rect x="64" y="18" width="14" height="25" rx="4" fill="white" fill-opacity="0.07"/>
      <rect x="60" y="14" width="80" height="33" rx="6" fill="none" stroke="#9A7C2C" stroke-width="0.7" stroke-opacity="0.6"/>
      <!-- AI tiny on cap -->
      <text x="100" y="34" text-anchor="middle" font-family="Georgia,serif" font-size="8" fill="#C8A84A" font-style="italic" opacity="0.7">AI</text>
    </svg>`;
  }
};

/* ── INIT ───────────────────────────────────────── */
document.addEventListener('DOMContentLoaded',()=>{
  Cursor.init();
  Particles.init();
  HeroBottle.init();
  Announce.init();
  Countdown.init();
  Header.init();
  CartDrawer.init();
  Cart.updateUI();
  MobileNav.init();
  Catalog.init();
  Quiz.init();
  Bundle.init();
  Notif.init();
  Popup.init();
  Newsletter.init();
  Reveal.init();
  initTilt();
  // Social proof random
  const names=['Carlos G.','Ana M.','Ricardo L.','Sofía P.','Diego R.'];
  const prods=['El Depredador','El Rey del Antro','La Noche es Tuya','Marea Eterna'];
  let idx=0;
  setInterval(()=>{
    Notif.show(`${names[idx%names.length]} agregó al carrito`,prods[idx%prods.length]);
    idx++;
  }, 18000 + Math.random()*8000);
});

/* ═══════════════════════════════════════════════════════
   PARCHE 2 — Shopify Cart API + Vol Selector + WA + Exit
   ═══════════════════════════════════════════════════════ */

/* ── 1. SHOPIFY CART API (reemplaza localStorage) ───────
   Detecta si corre en Shopify real o en preview.
   En Shopify real usa la AJAX API.
   En preview/desarrollo usa localStorage como fallback.
   ───────────────────────────────────────────────────── */
const ShopifyCart = {
  isShopify: typeof window.Shopify !== 'undefined' && !!window.Shopify.shop,

  /* Agrega un item. variantId viene de data-variant-id en el HTML.
     Si no hay variantId (preview), usa el fallback localStorage. */
  async add(variantId, qty = 1, productData = null) {
    if (!this.isShopify || !variantId) {
      // Fallback: usa el Cart de localStorage
      if (productData) Cart.addLocal(productData);
      return;
    }
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      });
      if (!res.ok) throw new Error('Cart add failed');
      await this.refresh();
    } catch (err) {
      console.warn('Shopify Cart API error:', err);
      if (productData) Cart.addLocal(productData);
    }
  },

  /* Lee el carrito real de Shopify */
  async get() {
    if (!this.isShopify) return null;
    try {
      const res = await fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      return await res.json();
    } catch { return null; }
  },

  /* Cambia cantidad de un item por variant_id */
  async change(variantId, qty) {
    if (!this.isShopify) return;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    await this.refresh();
  },

  /* Refresca el drawer con los datos reales */
  async refresh() {
    const data = await this.get();
    if (!data) return;
    // Sincroniza el Cart local con el estado real de Shopify
    Cart.items = data.items.map(item => ({
      key: String(item.variant_id),
      productId: item.variant_id,
      name: item.product_title,
      vol: item.variant_title || '100ml',
      price: item.price / 100,
      qty: item.quantity,
      icon: '🌸',
      variantId: item.variant_id
    }));
    Cart.updateUI();
  },

  /* Antes del checkout, limpia el carrito de Shopify y agrega
     todos los items del localStorage para sincronizar */
  async syncAndCheckout() {
    if (!this.isShopify) { window.location = '/checkout'; return; }
    try {
      // Limpia carrito Shopify
      await fetch('/cart/clear.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      // Agrega todos los items del localStorage usando variantIds
      const items = Cart.items.map(i => ({ id: i.variantId || i.productId, quantity: i.qty })).filter(i => i.id);
      if (items.length) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items })
        });
      }
      window.location = '/checkout';
    } catch {
      window.location = '/checkout';
    }
  }
};

/* Extiende Cart.add para usar Shopify cuando esté disponible */
const _origAdd = Cart.add.bind(Cart);
Cart.add = function(productId, vol) {
  const p = PRODUCTS.find(x => x.id === productId);
  if (!p || p.soon) { Notif.show('No disponible', 'Esta fragancia llega pronto', 'error'); return; }
  const price = vol === '30ml' ? p.p30 : p.p100;
  const variantId = vol === '30ml' ? p.variantId30 : p.variantId100;
  const productData = { key: `${productId}-${vol}`, productId, name: p.name, vol, price, qty: 1, icon: p.icon, variantId };
  // Intenta Shopify API primero, con el fallback local incluido
  ShopifyCart.add(variantId, 1, productData);
  // Si no es Shopify real, el fallback ya lo maneja. Si sí, refresh lo sincroniza.
  if (!ShopifyCart.isShopify) {
    Cart.addLocal(productData);
    CartDrawer.open();
    Notif.show('¡Agregado!', `${p.name} (${vol}) en tu carrito`, 'success');
  } else {
    // Feedback inmediato mientras la API responde
    Notif.show('Agregando...', `${p.name} (${vol})`, '');
    ShopifyCart.refresh().then(() => {
      CartDrawer.open();
      Notif.show('¡Agregado!', `${p.name} (${vol}) en tu carrito`, 'success');
    });
  }
};

/* Agrega al localStorage (fallback / preview) */
Cart.addLocal = function(productData) {
  const existing = this.items.find(i => i.key === productData.key);
  if (existing) { existing.qty++; }
  else { this.items.push({ ...productData, qty: 1 }); }
  this.save();
  this.updateUI();
};

/* Parchea el checkout para sincronizar con Shopify antes de redirigir */
const checkoutBtns = () => document.querySelectorAll('[onclick*="checkout"]');
document.addEventListener('click', e => {
  if (e.target.matches('[onclick*="checkout"]') || e.target.closest('[onclick*="checkout"]')) {
    e.preventDefault();
    ShopifyCart.syncAndCheckout();
  }
});


/* ── 2. SELECTOR DE VOLUMEN ─────────────────────────── */
const VolSelector = {
  /* Estado: productId → volumen seleccionado */
  state: {},

  /* Cambia el volumen activo de una card */
  set(productId, vol, btn) {
    this.state[productId] = vol;
    const card = btn.closest('.product-card');
    if (!card) return;
    // Actualiza botones
    card.querySelectorAll('.vol-btn').forEach(b => b.classList.toggle('active', b.dataset.vol === vol));
    // Actualiza precio visible
    const p = PRODUCTS.find(x => x.id === productId);
    if (!p) return;
    const priceEl = card.querySelector('.product-price-selected');
    if (priceEl) priceEl.textContent = `$${(vol === '30ml' ? p.p30 : p.p100).toLocaleString()} MXN`;
  },

  /* Devuelve el vol activo para una card, con default 100ml */
  get(productId) { return this.state[productId] || '100ml'; }
};

/* Sobrescribe Catalog.render para incluir el selector de volumen + descuento */
const _origRender = Catalog.render.bind(Catalog);
Catalog.render = function() {
  const grid = document.getElementById('catalog-grid');
  if (!grid) return;
  const visible = this.filter === 'todos' ? PRODUCTS : PRODUCTS.filter(p => p.cat === this.filter || p.vibe === this.filter);
  grid.innerHTML = visible.map(p => {
    const disc30  = Math.round((1 - p.p30  / p.p30orig)  * 100);
    const disc100 = Math.round((1 - p.p100 / p.p100orig) * 100);
    return `
    <div class="product-card${p.soon ? ' soon' : ''} reveal" data-id="${p.id}"
         data-variant-30="${p.variantId30 || ''}" data-variant-100="${p.variantId100 || ''}">
      <div class="product-card-img">
        ${p.img ? `<img src="${p.img}" alt="${p.name}" loading="lazy">` : `<div class="placeholder-icon">${p.icon}</div>`}
        <div class="product-card-badge">
          ${p.badge === 'hot' && !p.soon ? '<span class="badge badge-hot">🔥 Hot</span>' : ''}
          ${p.badge === 'new' && !p.soon ? '<span class="badge badge-new">Nuevo</span>' : ''}
          ${p.soon ? '<span class="badge badge-soon">Próximamente</span>' : ''}
        </div>
        ${!p.soon ? `
        <div class="card-disc-badge">-${disc100}%</div>
        <button class="product-wishlist" onclick="event.stopPropagation();this.classList.toggle('active')" aria-label="Lista de deseos">♡</button>` : ''}
        ${p.soon ? `<div class="soon-overlay"><div class="soon-badge">Próximamente<span>En 15 días</span></div></div>` : ''}
      </div>
      <div class="product-card-body">
        ${!p.soon ? '<div class="launch-ribbon">🏷 Precio de Lanzamiento</div>' : ''}
        <div class="product-cat">${p.cat} · ${p.vibe}</div>
        <div class="product-name">${p.name}</div>
        <div class="product-insp">${p.insp}</div>
        <div class="product-notes">${p.notes.slice(0,3).map(n=>`<span class="product-note">${n}</span>`).join('')}</div>
        ${!p.soon ? `
        <div class="vol-selector">
          <button class="vol-btn" data-vol="30ml" onclick="VolSelector.set(${p.id},'30ml',this)">
            30ml
            <span class="vol-orig">$${p.p30orig.toLocaleString()}</span>
            <span class="vol-price">$${p.p30.toLocaleString()}</span>
          </button>
          <button class="vol-btn active" data-vol="100ml" onclick="VolSelector.set(${p.id},'100ml',this)">
            100ml
            <span class="vol-orig">$${p.p100orig.toLocaleString()}</span>
            <span class="vol-price">$${p.p100.toLocaleString()}</span>
          </button>
        </div>
        <div class="product-price-row">
          <div class="price-stack">
            <span class="price-orig" id="orig-${p.id}">$${p.p100orig.toLocaleString()}</span>
            <span class="product-price-selected" id="price-${p.id}">$${p.p100.toLocaleString()} MXN</span>
            <span class="price-save" id="save-${p.id}">Ahorras $${(p.p100orig - p.p100).toLocaleString()}</span>
          </div>
          <button class="product-add" onclick="Cart.add(${p.id}, VolSelector.get(${p.id}))" aria-label="Agregar al carrito">+</button>
        </div>` : `
        <div class="product-price-row" style="margin-top:12px">
          <span class="product-price-s" style="color:var(--tx3)">30ml $${p.p30.toLocaleString()} · 100ml $${p.p100.toLocaleString()}</span>
          <button class="product-add" disabled aria-label="No disponible">⏳</button>
        </div>`}
      </div>
    </div>`;
  }).join('');
  Reveal.init();
  initTilt();
};

/* Actualiza precio + ahorro al cambiar volumen */
const _origVolSet = VolSelector.set.bind(VolSelector);
VolSelector.set = function(productId, vol, btn) {
  this.state[productId] = vol;
  const card = btn.closest('.product-card');
  if (!card) return;
  card.querySelectorAll('.vol-btn').forEach(b => b.classList.toggle('active', b.dataset.vol === vol));
  const p = PRODUCTS.find(x => x.id === productId);
  if (!p) return;
  const price = vol === '30ml' ? p.p30 : p.p100;
  const orig  = vol === '30ml' ? p.p30orig : p.p100orig;
  const save  = orig - price;
  const priceEl = document.getElementById(`price-${productId}`);
  const origEl  = document.getElementById(`orig-${productId}`);
  const saveEl  = document.getElementById(`save-${productId}`);
  if (priceEl) priceEl.textContent = `$${price.toLocaleString()} MXN`;
  if (origEl)  origEl.textContent  = `$${orig.toLocaleString()}`;
  if (saveEl)  saveEl.textContent  = `Ahorras $${save.toLocaleString()}`;
};

/* ── RE-INIT ────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {
  /* Re-renderiza catálogo con vol selector */
  Catalog.render();
  /* Inicia los módulos nuevos */
  WAButton.init();
  ExitIntent.init();
  /* Si es Shopify real, sincroniza el carrito al cargar */
  if (ShopifyCart.isShopify) ShopifyCart.refresh();
});


/* HOT SALE COUNTDOWN */
document.addEventListener('DOMContentLoaded',()=>{
 const endDate = new Date();
 endDate.setDate(endDate.getDate()+10);

 function updateHotSaleCountdown(){
   const now = new Date().getTime();
   const distance = endDate - now;

   const days = Math.floor(distance / (1000 * 60 * 60 * 24));
   const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
   const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
   const seconds = Math.floor((distance % (1000 * 60)) / 1000);

   document.getElementById('days') && (document.getElementById('days').innerText = days);
   document.getElementById('hours') && (document.getElementById('hours').innerText = String(hours).padStart(2,'0'));
   document.getElementById('minutes') && (document.getElementById('minutes').innerText = String(minutes).padStart(2,'0'));
   document.getElementById('seconds') && (document.getElementById('seconds').innerText = String(seconds).padStart(2,'0'));
 }

 setInterval(updateHotSaleCountdown,1000);
 updateHotSaleCountdown();
});
